import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Home from "./Homes";
import Contacto from "./Contacto";
import producto from "./producto";

function App() {
  return (
    <Router>
            <Header />
           {" "}
      <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contacto" element={<Contacto />} />
                     {" "}
      </Routes>
            <Footer />
         {" "}
    </Router>
  );
}

export default App;
0;
